import RelatedClinicalTrialsBlock from './RelatedClinicalTrialsBlock';

globalThis.RelatedClinicalTrialsComponents = {
  RelatedClinicalTrialsBlock,
};
